<div class="feature feature-6">
  <div *ngIf="isNumberValue" class="pie" [ngClass]="['p' + numberValue]"></div>
  <div *ngIf="!isNumberValue" class="pie p100">
    <span>{{ data?.indice }}</span>
  </div>

  <h4 *ngIf="data?.name">{{ data?.name }}</h4>
  <p *ngIf="data?.description">{{ data?.description }}</p>
</div>
